import { Button, Modal, Select, TextInput } from "flowbite-react";
import ReactQuill from "react-quill";
import AutoCompleteInput from "../inputs/Autocomplete";
import TaskTimePicker from "../inputs/TaskTimePicker";
import AttachmentPicker from "../inputs/AttachmentPicker";

// ===== MODAL DE EDIÇÃO DE TAREFA =====
export default function TaskEditModal({
  open,
  onClose,
  taskBeingEdited, // objeto da tarefa sendo editada (t)
  editingData, // { editType, editNoteHtml, editDueDate, editDueTime, editResponsibleIds }
  setEditType,
  setEditNoteHtml,
  setEditDueDate,
  setEditDueTime,
  setEditResponsibleIds,
  userOptions,
  loadingUsers,
  saveEditTask,
  cancelEditTask, // limpa estados locais
  onDeleteAttachment, // remover anexo existente
  editFiles, // novos anexos selecionados na edição
  setEditFiles, // setter dos novos anexos
  quillModules,
  labelMap,
  quillFormats,
  prettySize,
  fileIconFor,
}) {
  if (!open || !taskBeingEdited) return null;

  const t = taskBeingEdited;

  return (
    <Modal show={open} onClose={onClose} size="3xl">
      <Modal.Header>Editar tarefa</Modal.Header>
      <Modal.Body>
        <div className="grid grid-cols-1 gap-4">
          {/* Tipo */}
          <div>
            <label className="text-xs text-gray-600 block mb-1">Tipo</label>
            <Select
              value={editingData.editType}
              onChange={(e) => setEditType(e.target.value)}
            >
              <option value="">—</option>
              {Object.entries(labelMap).map(([k, v]) => (
                <option key={k} value={k}>
                  {v}
                </option>
              ))}
            </Select>
          </div>

          {/* Descrição (Quill) */}
          <div>
            <label className="text-xs text-gray-600 block mb-1">
              Descrição
            </label>
            <div className="border rounded-md bg-white">
              <ReactQuill
                value={editingData.editNoteHtml}
                onChange={setEditNoteHtml}
                modules={quillModules}
                formats={quillFormats}
                theme="snow"
              />
            </div>
          </div>

          {/* Anexos existentes (com remover) */}
          {Array.isArray(t.attachments) && t.attachments.length > 0 && (
            <div>
              <label className="text-xs text-gray-600 block mb-1">Anexos</label>
              <ul className="space-y-1">
                {t.attachments.map((a) => {
                  const name =
                    a.originalName ||
                    a.filename ||
                    a.name ||
                    a.objectName ||
                    a.gcsKey ||
                    "arquivo";
                  const size = a.size ? ` • ${prettySize(a.size)}` : "";
                  const icon = fileIconFor(
                    a.mimeType || a.mimetype || "",
                    name
                  );
                  return (
                    <li
                      key={a.id || a.objectName || a.gcsKey || name}
                      className="flex items-center gap-2"
                    >
                      <span className="shrink-0">{icon}</span>
                      <span
                        className="text-sm text-gray-800 truncate"
                        title={name}
                      >
                        {name}
                      </span>
                      <span className="text-gray-400 text-xs">{size}</span>
                      <button
                        type="button"
                        className="ml-auto text-xs text-red-600 hover:underline"
                        onClick={() => onDeleteAttachment?.(t, a)}
                        title="Excluir anexo"
                      >
                        Remover
                      </button>
                    </li>
                  );
                })}
              </ul>
            </div>
          )}

          {/* Novos anexos */}
          <AttachmentPicker
            label="Adicionar novos anexos"
            files={editFiles}
            onChange={setEditFiles}
            accept="image/*,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
          />

          {/* Data / Hora */}
          <div className="grid grid-cols-2 gap-2">
            <TextInput
              type="date"
              value={editingData.editDueDate}
              onChange={(e) => setEditDueDate(e.target.value)}
            />
            <TaskTimePicker
              value={editingData.editDueTime}
              onChange={setEditDueTime}
              step={5}
              preferAbove
            />
          </div>

          {/* Responsável */}
          <div>
            <label className="text-xs text-gray-600 block mb-1">
              Responsáveis
            </label>
            <AutoCompleteInput
              label=""
              name={`edit-task-resp-${t.id}`}
              options={userOptions}
              value={editingData.editResponsibleIds || []}
              onChange={(opt) =>
                setEditResponsibleIds(
                  Array.isArray(opt)
                    ? opt.map((o) => o.value)
                    : opt?.value
                    ? [opt.value]
                    : []
                )
              }
              isLoading={loadingUsers}
              isMulti
              isClearable
            />
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div className="w-full flex justify-end gap-2">
          <Button
            size="sm"
            color="light"
            onClick={() => {
              cancelEditTask();
              onClose();
            }}
          >
            Cancelar
          </Button>
        </div>
        <Button
          size="sm"
          onClick={async () => {
            await saveEditTask(t); // já usa editFiles/estado atual
            onClose();
          }}
        >
          Salvar
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
